import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles, Icon } from '@Sage/hoi-poi-ui';

import styles from './styles';
const useStyles = createUseStyles(styles, 'Image');

function Image({ img, index, onDelete, onView, ...props }) {
    const classes = useStyles();

    const handleView = useCallback(() => {
        onView(index);
    }, [index, onView]);

    const handleDelete = useCallback(
        (event) => {
            event.stopPropagation();
            onDelete(index);
        },
        [index, onDelete],
    );

    return (
        <div
            className={classes.root}
            role="button"
            tabIndex="0"
            onClick={handleView}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    handleView();
                }
            }}
        >
            <img
                className={classes.img}
                src={img.strLink}
                alt={img.description}
                height="80"
                width="80"
            />
            <div className={classes.delete} onClick={handleDelete}>
                <Icon name="trash" size="medium" />
            </div>
        </div>
    );
}

Image.propTypes = {
    img: PropTypes.object.isRequired,
    onDelete: PropTypes.func.isRequired,
    onView: PropTypes.func.isRequired,
};

export default memo(Image);
